<script setup lang="ts">
import type { EntityAdministrator } from "~/core/models/EntityAdministrator.interface";

const { t } = useI18n();

const model: Ref<EntityAdministrator> = defineModel<EntityAdministrator>({
  required: true,
});
</script>
<template>
  <h3 class="mb-4">{{ t("administration.entityAdmin.title") }}</h3>
  <div class="grid gap-x-8 grid-cols-2">
    <lxc-form-item
      :label="t('administration.entityAdmin.lastname')"
      prop="administrator.lastName"
      class="basis-1/2"
    >
      <lxc-input v-model="model.lastName" type="text" />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityAdmin.firstname')"
      prop="administrator.firstName"
      class="basis-1/2"
    >
      <lxc-input v-model="model.firstName" type="text" />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityAdmin.login')"
      prop="administrator.login"
      class="basis-1/2"
    >
      <lxc-input v-model="model.login" type="text" />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityAdmin.email')"
      prop="administrator.email"
      class="basis-1/2"
    >
      <lxc-input v-model="model.email" type="email" />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityAdmin.language')"
      prop="administrator.language"
      class="basis-1/2"
    >
      <language-component v-model="model.language" />
    </lxc-form-item>
  </div>
</template>
